import { View } from "react-native";
import { Text } from "react-native-paper";
import TabJobsIcon from "../../svgs/TabJobsIcon";
import { colors } from "../../../theme";
import { Button } from "../../components";

interface NavigationParams {
  screen?: string;
  params?: NavigationParams;
}

interface Navigation {
  navigate(screen: string, params?: NavigationParams): void;
  getParent(name: "root"): Navigation | undefined;
}

export const navigateToJobSearch = (navigation: Navigation) => () => {
  navigation.getParent("root")?.navigate("Main", { screen: "Jobs", params: { screen: "JobSearch" } });
};

export default ({ navigation }: { navigation: Navigation }) => (
  <View className="flex-col items-center justify-center flex-1 mb-10">
    <TabJobsIcon color={colors.ink.lighter} width={81} height={80} />
    <Text className="text-large-tight text-ink-light font-700 mt-4">No Matching Jobs</Text>

    <Text className="text-regular-tight font-400 mt-1 mx-8 text-center text-ink-light">
      Adjust keywords, location, or filter criteria to see additional jobs.
    </Text>

    <Button mode="light" className="mt-6" onPress={navigateToJobSearch(navigation as Navigation)}>
      Try Another Search
    </Button>
  </View>
);
